query getLandingpageByType($input: GetLandingpageByTypeInput!) {
  returnCallLandingpage: getLandingpageByType(input: $input) {
    originalUrl
    customUrl
  }
}
